import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class BodyCarPriority extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  bodycarPriorityState: this.props.bodycarPriority,
                  selectedBodycarPriority: {
                        value: this.props.bodycarPriority.bodycar_price_priority_bodycar_discnt_priority_id,
                        label: this.props.bodycarPriority.bodycar_discnt_priority_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  optionBodycarPriority: [],
            }
      }
      componentDidMount() {
            this.getoptionBodycarPriority()
      }

      getoptionBodycarPriority = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].bodycar_discnt_priority_id, label: arr.data[k].bodycar_discnt_priority_name })
                              }
                              self.setState({ optionBodycarPriority: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_discnt_priority")
            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleInstalmentMode = (selectedBodycarPriority) => {
            var temparray = this.state.bodycarPriorityState
            temparray.bodycar_price_priority_bodycar_discnt_priority_id = selectedBodycarPriority.value
            this.setState({ selectedBodycarPriority: selectedBodycarPriority, bodycarPriorityState: temparray })
      }

      handleChangeConditionsPercent = (event) => {
            var temparray = this.state.bodycarPriorityState
            temparray.bodycar_price_priority_percent = event
            this.setState({ bodycarPriorityState: temparray })
      }

      modifyNewInstalmentCondition = () => {
            const { bodycarPriorityState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_pricepriority")
            fd.append("bodycar_price_priority_id", bodycarPriorityState.bodycar_price_priority_id)
            fd.append("bodycar_price_priority_percent", bodycarPriorityState.bodycar_price_priority_percent)

            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { bodycarPriorityState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_pricepriority")
            fd.append("bodycar_price_priority_id", bodycarPriorityState.bodycar_price_priority_id)

            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const { optionBodycarPriority, snackMode, snackstr, showSnack, visible, selectedBodycarPriority, bodycarPriorityState } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={5}>
                                    <div>
                                          <label className="on">نام تخفیف </label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"نام تخفیف"}
                                                value={selectedBodycarPriority}
                                                onChange={this.handleInstalmentMode}
                                                options={optionBodycarPriority}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={4}>
                                    <FloatingLabelInput
                                          type="number"
                                          placeholder="اولویت محاسبه تخفیف"
                                          handleInputt={this.handleChangeConditionsPercent}
                                          value={bodycarPriorityState.bodycar_price_priority_percent}
                                    />
                              </Grid>

                              <Grid item xs={3}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(BodyCarPriority)
